export const environment = {
  ENABLE_PROD_MODE: false,
  API_URL: "https://fluidrapoolapi.zodiac-staging.com/v1",
  NGAC_URL:"https://iot2-api.fluidra-io-staging.com",
  TOKEN_URL:"https://fluidrapool-stage.auth.us-east-1.amazoncognito.com/oauth2/token",
  SIGN_IN_AUTH_URL:"https://fluidrapool-stage.auth.us-east-1.amazoncognito.com/oauth2/authorize",
  CLIENT_ID:"67gqmkev33g4ct0rnng2nfmdk7",
  CLIENT_SECRET_ID:"15m0qlm4qk9e3pa647ksbptn3cedul38d6go5a55pndjoshr9lp3",
  REDIRECT_URL: window.location.origin + "/support-portal",
  SIGN_OUT_AUTH_URL:"https://fluidrapool-stage.auth.us-east-1.amazoncognito.com/oauth2/revoke",
  HTTP_REQ_TIMEOUT_DURATION: 20000,
  COGNITO_IDP_URL: 'https://cognito-idp.us-east-1.amazonaws.com',
  REGION : 'us-east-1',
  XAPIKEY : 'Q76wfXN/dRQ|X/ZQ2{h+1%lvV"-SAum]',
  PRO_API_BASE_URL: "https://staging.fluidrapro-io.com/api/businesses/v1",
  PRO_API_BASE_URL_V2: "https://staging.fluidrapro-io.com/v2",
  NGA_API_DOMAIN_DEV_INT: 'https://iot2-api.fluidra-io-stage.com' ,
  GraphQL: {
    endpoint: 'iot2-appsync.fluidra-io-stage.com'
  },
  ROBOTS_API_URL: "https://iot1-5-api.fluidra-io-stage.com/v1",
  API_SECRET_KEY_ROBOTS: "ZCV8AO62Q5XJHD0A|GSRmRcQ4CAZJfSxJVI0wGQ"
 
};